import { AccountType, useRepositoryQuery, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { WithAccountId } from '@mews-commander/types';

export const useGetAccountIsCompany = ({ accountId, enabled = true }: WithAccountId & { enabled?: boolean }) =>
    useRepositoryQuery(
        'accounts',
        'getAll',
        {
            accountIds: [accountId],
        },
        {
            select: (data) => data.accounts?.some((account) => account.data.discriminator === AccountType.Company),
            enabled,
        }
    );

export const useGetAccountIsCompanySuspense = ({ accountId }: WithAccountId) =>
    useRepositorySuspenseQuery(
        'accounts',
        'getAll',
        {
            accountIds: [accountId],
        },
        {
            select: (data) => data.accounts?.some((account) => account.data.discriminator === AccountType.Company),
        }
    );
